<template>
  <q-banner
    v-if="visible"
    inline-actions
    class="bg-black text-white cookie-banner"
  >
    We use cookies to ensure that we give you the best experience on our
    website. If you continue to use this site we will assume that you are
    happy with it.
    <template #action>
      <q-btn flat label="OK" color="white" @click="accept" />
    </template>
  </q-banner>
</template>

<script setup>
import { ref, onMounted } from "vue"
import Cookies from "js-cookie"

const COOKIE_NAME = "cookies-accepted"
const visible = ref(false)

onMounted(() => {
  visible.value = Cookies.get(COOKIE_NAME) !== "1"
})

const accept = () => {
  Cookies.set(COOKIE_NAME, "1", { expires: 365 })
  visible.value = false
}
</script>

<style lang="scss" scoped>
.cookie-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
}
</style>
